import React from "react";

import { Grid } from "@material-ui/core";
import Chip from "../basics/Chip";
import { StyledCard, Padding } from "./styles/Card";

const Card = ({
  children,
  line = "",
  lineColor = "secondary",
  label,
  chipcolor = "secondary",
  chiptextcolor = "black",
  padding = "12",
  full = false,
  fullWidth = false,
  fullHeight = false,
  ...props
}) => {
  return (
    <StyledCard
      full={full}
      line={line}
      lineColor={lineColor}
      padding={padding}
      $fullWidth={fullWidth}
      fullHeight={fullHeight}
      {...props}
    >
      {label ? (
        <>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12}>
              <Chip
                bgcolor={chipcolor}
                textcolor={chiptextcolor}
                label={label}
              />
            </Grid>
          </Grid>
          <Padding padding="7">{children}</Padding>
        </>
      ) : (
        <>{children} </>
      )}
    </StyledCard>
  );
};

export default Card;
